import { render, staticRenderFns } from "./unpaid_payment_details.vue?vue&type=template&id=4b9b2e30&scoped=true&"
import script from "./unpaid_payment_details.vue?vue&type=script&lang=js&"
export * from "./unpaid_payment_details.vue?vue&type=script&lang=js&"
import style0 from "./unpaid_payment_details.vue?vue&type=style&index=0&id=4b9b2e30&prod&lang=scss&scoped=true&"
import style1 from "./unpaid_payment_details.vue?vue&type=style&index=1&id=4b9b2e30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9b2e30",
  null
  
)

export default component.exports